import queryString from 'query-string'

const siteSearchEndpoint = '/api/search'

const getRequestURL = (endpoint, params) => `${endpoint}?${queryString.stringify(params)}`

export default async function fetchSiteSearch({q, page, pageSize}) {
  try {
    const url = getRequestURL(siteSearchEndpoint, {
      q,
      page,
      pageSize,
    })
    const {data} = await fetchFromApi(url)
    return {response: data}
  } catch (error) {
    return {error}
  }
}

async function fetchFromApi(url) {
  const response = await fetch(url, {method: 'GET'})
  if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)
  return await response.json()
}



// WEBPACK FOOTER //
// ./src/apis/site-search.js